import { useEffect } from "react";
import { userType } from "../constants/user";
import { create } from "zustand";
import { User } from "../types/user";
import { AppUserSession } from "../services/user-session";

interface CurrentTalentState {
  user: User | null;
  setUser: (user: User | null) => void;
  authToken: null | string;
  setAuthToken: (token: string | null) => void;
  resetUser: () => void;
}

const useAuthStore = create<CurrentTalentState>()((set) => ({
  user: null,
  setUser: (user) =>
    set(() => ({
      user,
    })),
  authToken: null,
  setAuthToken: (token) =>
    set(() => ({
      authToken: token,
    })),
  resetUser: () => set(() => ({ user: null })),
}));

export function useAuth() {
  const { user, setUser, authToken, setAuthToken, resetUser } = useAuthStore();
  useEffect(() => {
    if (!authToken) {
      const token = AppUserSession.getToken();
      if (token) setAuthToken(token);
    }
  }, [authToken, setAuthToken]);

  return {
    accessToken: authToken,
    userInfo: user,
    isUserLogin: authToken && user?.account_type === userType.USER,
    isTalentLogin: authToken && user?.account_type === userType.TALENT,
    isBusinessLogin: authToken && user?.account_type === userType.BUSINESS,
    setUser,
    setAuthToken,
    resetUser,
  };
}
